import { ChangeDetectionStrategy, Component, input, TemplateRef, viewChild } from '@angular/core';

/**
 * Výchozí šablony PrimeNG tabulky přehledu (ikona řazení, hláška prázdné tabulky). Komponentu nevkládá
 * šablona – vytváří ji BrowseTableDirective mimo DOM a bere si z ní TemplateRef.
 */
@Component({
  selector: 'ui-browse-table-templates',
  template: `
    <ng-template #sortIcon let-sortOrder>
      <i
        [class.pi-sort-alt]="sortOrder === 0"
        [class.pi-sort-amount-down]="sortOrder === -1"
        [class.pi-sort-amount-up-alt]="sortOrder === 1"
        class="pi">
      </i>
    </ng-template>
    <ng-template #emptyMessage>
      @if (emptyText() !== null) {
        <tr>
          <td [attr.colspan]="emptyColspan()">
            <div class="p-8 text-center text-(--text-secondary)">{{ emptyText() }}</div>
          </td>
        </tr>
      }
    </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrowseTableTemplatesComponent {
  /** null = bez řádku hlášky (tělo prázdné tabulky zůstane prázdné). */
  readonly emptyText = input<string | null>('Nejsou data k zobrazení.');
  /** Buňka přes všechny sloupce; prohlížeč colspan větší než počet sloupců ořízne. */
  readonly emptyColspan = input(100);

  readonly sortIcon = viewChild.required<TemplateRef<unknown>>('sortIcon');
  readonly emptyMessage = viewChild.required<TemplateRef<unknown>>('emptyMessage');
}
